export enum TOOLTIP_TYPES {
  DEFAULT = 'default',
  RX_GREEN = 'rxgreen',
}

export enum TOOLTIP_SIDES {
  TOP = 'top',
  BOTTOM = 'bottom',
  RIGHT = 'right',
  LEFT = 'left',
}
